<!-- Home Section -->
<section id="home" class="container-fluid home-Section">

  <div class="container content-main text-center">
    <h2 class="main-text">Software & Tech-Enabled Services for Businesses</h2>
<!--    <h2 class="main-text">Fighting Covid-19: We are at the forefront</h2>-->
<!--    <p class="text-center text-white" style=""><a style="text-decoration: none;color: white" routerLink="/insights/fighting-covid-19-we-are-at-the-forefront">Find out more...</a></p>-->
  </div>

</section>



<!--Services Section-->
<section id="services" class="service-section">

  <div class="container">
    <h2><b>Functions</b></h2>

    <div class="first-tabs show-mobile">
      <div class="nav nav-pills nav-fill">
        <div class="services-slider owl-carousel owl-theme">
<!--          <div class="item ml-0">-->
<!--            <div class="nav-item">-->
<!--              <a class="nav-link" (click)="changeTabs($event)" data-toggle="pill" href="#consulting">-->
<!--                <i class="fas fa-user-tie icon-font"></i><br>-->
<!--                Consulting-->
<!--&lt;!&ndash;                Staffing&ndash;&gt;-->
<!--              </a>-->
<!--            </div>-->
<!--          </div>-->

          <div class="item ml-0">
            <div class="nav-item">
              <a class="nav-link active" (click)="changeTabs($event)" data-toggle="pill" href="#techTransformation">
                <i class="fas fa-laptop icon-font"></i><br>Software</a>
            </div>
          </div>

          <div class="item ml-0">
            <div class="nav-item">
              <a class="nav-link" (click)="changeTabs($event)" data-toggle="pill" href="#software">
                <i class="fa fa-desktop"></i><br>Web Application</a>
            </div>
          </div>
          <div class="item ml-0">
            <div class="nav-item">
              <a class="nav-link" (click)="changeTabs($event)" data-toggle="pill" href="#mobileapps">
                <i class="fas fa-mobile-alt icon-font"></i><br>Mobile Apps</a>
            </div>
          </div>


          <div class="item ml-0">
            <div class="nav-item">
              <a class="nav-link" (click)="changeTabs($event)" data-toggle="pill" href="#digitalmarketing">
                <i class="fas fa-bullhorn icon-font"></i><br>Digital Marketing</a>
            </div>
          </div>

        </div>
      </div>
    </div>




    <div class="row d-flex my-4 margin-services show-web">
      <div class="col">
        <div class="first-tabs" style="width: 100%;margin-left: auto;margin-right: auto;">
          <ul class="nav nav-pills nav-fill">
<!--            <li class="nav-item first-li">-->
<!--              <a class="nav-link active" data-toggle="pill" href="#consulting">-->
<!--                <i class="fas fa-user-tie icon-font"></i><br>-->
<!--                Consulting-->
<!--&lt;!&ndash;                Staffing&ndash;&gt;-->
<!--              </a>-->
<!--            </li>-->

            <li class="nav-item first-li">
              <a class="nav-link active" data-toggle="pill" href="#techTransformation">
                <i class="fas fa-user-tie icon-font"></i><br>
                Tech Transformation
              </a>
            </li>
            <li class="nav-item mx-2">
              <a class="nav-link" data-toggle="pill" href="#software">
                <i class="fa fa-desktop"></i><br>Web Application</a>
            </li>
            <li class="nav-item mx-2">
              <a class="nav-link" data-toggle="pill" href="#mobileapps">
                <i class="fas fa-mobile-alt icon-font"></i><br>Mobile Apps</a>
            </li>
            <li class="nav-item mx-2">
              <a class="nav-link" data-toggle="pill" href="#digitalmarketing">
                <i class="fas fa-bullhorn icon-font"></i><br>Digital Marketing</a>
            </li>

          </ul>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col">

        <div class="tab-content" style="margin-top: 10px">

          <div id="techTransformation" class="tab-pane fade show active">

            <div class="row">
              <div class="col-12 col-sm-12 col-md-6">
                <p>We deliver end-to-end technology enabled transformations:</p>
                <p><b>Project discovery & design, web & mobile development, data infrastructure & cloud, enterprise architecture, technology sourcing.</b></p>
                <p>Whether it's an e-commerce website, ERP software, mobile app or upgradation of a legacy system, we provide services that optimize operations, accelerate growth & harness the power of data & analytics. Every developed repository is functional, compatible & scalable so that client's stay ahead of the market long after we've delivered the project.</p>
                <div style="text-align: center">
                  <p><strong style="cursor: pointer" routerLink="/services">Learn More ...</strong></p>
                </div>
              </div>
              <div class="col-12 col-sm-12 col-md-6 boxes" style="padding-left: 25px;padding-right: 22px;">
                <div class="row">
                  <div class="col-12 mt-2" style="text-align: center">
<!--                    <img src="assets/images/software-tab.JPG" style="" class="img-fluid" alt="">-->
                    <img src="assets/images/IrvineTek-Tech-Transformation.jpg" style="width: 100%" class="img-fluid" alt="">
                  </div>
                </div>
              </div>
            </div>

          </div>

          <div id="software" class="tab-pane fade">

            <div class="row">
              <div class="col-12 col-sm-12 col-md-6">
                <p>We discover, design & develop:</p>
                <p><b>WordPress, Shopify & customized ecommerce websites, corporate portals, front & back-office applications, ERP solutions</b></p>
                <p>We plan ahead for functionality, compatibility, scalability and integration so that every project is successfully completed within desired time and budget. We understand the significance of interactive interfaces & thorough testing of every repository. Our team actively engages to discuss suitable tech stack including frameworks (frontend & backend) & databases.</p>
                <div style="text-align: center">
                  <p><strong style="cursor: pointer" routerLink="/services">Learn More ...</strong></p>
                </div>
              </div>
              <div class="col-12 col-sm-12 col-md-6 boxes" style="padding-left: 25px;padding-right: 22px;">
                <div class="row">
                  <div class="col-12 mt-2" style="text-align: center">
                    <img src="assets/images/IrvineTek-Software-Development-Services.JPG" style="" class="img-fluid" alt="">
                  </div>
                </div>
              </div>
            </div>

          </div>


          <div id="mobileapps" class="tab-pane fade">

            <div class="row">
              <div class="col-12 col-sm-12 col-md-6">
                <p>Customized Android & iOS applications:</p>
                <p><b>Native Android & iOS applications, cross-platform applications, Progressive Web Apps (PWA), UI/UX, Wireframing</b></p>
                <p>We help you choose right development platform based on your business requirements, application functionality & budget. Native applications are developed for a single platform. Cross-platform is compatible with Android & iOS and is more affordable. PWA is a website that is designed to provide app like experience and usually costs less than other options.</p>
                <div style="text-align: center">
                  <p><strong style="cursor: pointer" routerLink="/services">Learn More ...</strong></p>
                </div>
              </div>
              <div class="col-12 col-sm-12 col-md-6 boxes" style="padding-left: 25px;padding-right: 22px;">
                <div class="row">
                  <div class="col-12 mt-2" style="text-align: center">
                    <img src="assets/images/IrvineTek-Mobile-Application-Development.jpeg" class="img-fluid" alt="" style="max-height: 380px;">
                  </div>
                </div>
              </div>
            </div>

          </div>

          <div id="digitalmarketing" class="tab-pane fade">

            <div class="row">
              <div class="col-12 col-sm-12 col-md-6">
                <p>Grow your business with digital marketing:</p>
                <p><b>Digital designs & campaigns, Search Engine Optimization (SEO), Pay-Per-Click (PPE), analytics & social media management</b></p>
                <p>75% customers use search engines to find local business information. SEO is the most efficient, free and organic way to make your business visible to target audience. Our SEO services help you with meta tags, title tags, keywords density so that your website ranks higher. We also prepare & run paid campaigns to promote your business on social media.</p>
                <div style="text-align: center">
                  <p><strong style="cursor: pointer" routerLink="/services">Learn More ...</strong></p>
                </div>
              </div>
              <div class="col-12 col-sm-12 col-md-6 boxes">
                <div class="row">
                  <div class="col mt-2" style="text-align: center">
<!--                    <img src="assets/images/Digital_Marketing_SEO_Services%20ii.JPG" class="img-fluid" alt="">-->
                    <img src="assets/images/IrvineTek-Digital-Marketing-and-SEO-Services.jpeg" class="img-fluid" alt="" style="max-height: 380px;">
                  </div>
                </div>
              </div>
            </div>

          </div>


        </div>

      </div>
    </div>
  </div>

</section>


<section id="servicesSub">
  <div class="container">

    <div class="row">
      <div class="col-12 col-sm-3 col-md-3 servicesSubMain">
        <p class="servicesSubHeading">IrvineTek.</p>
        <p class="servicesSubText">Digital Intelligence</p>
      </div>
      <div class="col-12 col-sm-3 col-md-3 servicesSubMain border-left-service">
        <p class="servicesSubHeading"> >55 </p>
        <p class="servicesSubText">Technology Transformations<br> carried out by our teams</p>
      </div>
      <div class="col-12 col-sm-3 col-md-3 servicesSubMain border-left-service">
        <p class="servicesSubHeading"> >30k </p>
        <p class="servicesSubText"> End-users <br> using our softwares</p>
      </div>
      <div class="col-12 col-sm-3 col-md-3 servicesSubMain border-left-service">
        <p class="servicesSubHeading"> >110M </p>
        <p class="servicesSubText">Data Points <br> generated using our systems</p>
      </div>
    </div>

  </div>
</section>


<!--Industries Section-->
<section id="portfolio" class="industries-section">

  <div class="container">
    <h2 class="pt-5"><b>Portfolio</b></h2>

    <div class="row" style="">
      <div class="col-sm-12 show-mobile">
        <div class="second-tabs">
          <div class="nav nav-pills nav-fill">
            <div class="industries-slider owl-carousel owl-theme">
              <div class="item ml-0">
                <div class="nav-item">
                  <a class="nav-link active" (click)="changeTabsInd($event)" data-toggle="pill" href="#healthcare">
                    <i class="fas fa-user-tie icon-font"></i><br>Healthcare</a>
                </div>
              </div>
              <div class="item ml-0">
                <div class="nav-item">
                  <a class="nav-link" (click)="changeTabsInd($event)" data-toggle="pill" href="#restaurants">
                    <i class="fas fa-utensils icon-font"></i><br>Restaurants</a>
                </div>
              </div>
              <div class="item ml-0">
                <div class="nav-item">
                  <a class="nav-link" (click)="changeTabsInd($event)" data-toggle="pill" href="#startups">
                    <i class="fas fa-store icon-font"></i><br>Startups</a>
                </div>
              </div>
              <div class="item ml-0">
                <div class="nav-item">
                  <a class="nav-link" (click)="changeTabsInd($event)" data-toggle="pill" href="#retail">
                    <i class="fas fa-city icon-font"></i><br>Retail</a>
                </div>
              </div>
              <div class="item ml-0">
                <div class="nav-item">
                  <a class="nav-link" (click)="changeTabsInd($event)" data-toggle="pill" href="#realestate">
                    <i class="fas fa-home icon-font"></i><br>Real Estate</a>
                </div>
              </div>
              <div class="item ml-0">
                <div class="nav-item">
                  <a class="nav-link" (click)="changeTabsInd($event)" data-toggle="pill" href="#publicservice">
                    <i class="fas fa-hands icon-font"></i><br>Public Service</a>
                </div>
              </div>
              <div class="item ml-0">
                <div class="nav-item">
                  <a class="nav-link" (click)="changeTabsInd($event)" data-toggle="pill" href="#edtech">
                    <i class="fas fa-graduation-cap icon-font"></i><br>EdTech</a>
                </div>
              </div>
              <div class="item ml-0">
                <div class="nav-item">
                  <a class="nav-link" (click)="changeTabsInd($event)" data-toggle="pill" href="#backOffice">
                    <i class="fas fa-hand-holding-usd icon-font"></i><br>Back Office</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-sm-12 col-md-12 col-lg-4 show-web">
        <div class="second-tabs">
          <ul class="nav nav-pills nav-fill indus-tabs">
            <!--              <div class="row">-->
            <!--              <div class="col-6 my-2">-->
            <li class="nav-item">
              <a class="nav-link active" data-toggle="pill" href="#healthcare">
                <i class="fas fa-user-tie icon-font"></i><br>Healthcare</a>
            </li>
            <!--              </div>-->
            <!--              <div class="col-6 my-2">-->
            <li class="nav-item">
              <a class="nav-link" data-toggle="pill" href="#restaurants">
                <i class="fas fa-utensils icon-font"></i><br>Restaurants</a>
            </li>
            <!--              </div>-->
            <!--              <div class="col-6 my-2">-->
            <li class="nav-item">
              <a class="nav-link" data-toggle="pill" href="#startups">
                <i class="fas fa-store icon-font"></i><br>Startups</a>
            </li>
            <!--              </div>-->
            <!--              <div class="col-6 my-2">-->
            <li class="nav-item">
              <a class="nav-link" data-toggle="pill" href="#retail">
                <i class="fas fa-city icon-font"></i><br>Retail</a>
            </li>
            <!--              </div>-->
            <!--              <div class="col-6 my-2">-->
            <li class="nav-item">
              <a class="nav-link" data-toggle="pill" href="#realestate">
                <i class="fas fa-home icon-font"></i><br>Real Estate</a>
            </li>
            <!--              </div>-->
            <!--              <div class="col-6 my-2">-->
            <li class="nav-item">
              <a class="nav-link" data-toggle="pill" href="#publicservice">
                <i class="fas fa-hands icon-font"></i><br>Public Service</a>
            </li>
            <!--              </div>-->
            <!--              <div class="col-6 my-2">-->
            <li class="nav-item">
              <a class="nav-link" data-toggle="pill" href="#edtech">
                <i class="fas fa-graduation-cap icon-font"></i><br>EdTech</a>
            </li>
            <!--              </div>-->
            <!--              <div class="col-6 my-2">-->
            <li class="nav-item">
              <a class="nav-link" data-toggle="pill" href="#backOffice">
                <i class="fas fa-hand-holding-usd icon-font"></i><br>Back Office</a>
            </li>
            <!--              </div>-->
            <!--              </div>-->
          </ul>
        </div>
      </div>
      <div class="col-12 col-sm-12 col-md-12 col-lg-8 second-tab-detail">
        <div class="tab-content">

          <div id="healthcare" class="tab-pane fade show active">

            <div class="row">
              <div class="col-12">
                <p><b>Hospitals, Pharmacies, Labs, Telemedicine</b></p>
                <p>We are providing on-premise & cloud-based healthcare solutions to several public & private sector hospitals. Designed, developed & customized by us, Camden Health System offers multiple clinical & non-clinical modules. Over 40 million patients have been successfully provided healthcare services through our system.</p>
                <p>Every day, we empower thousands of healthcare professionals to provide patient care in a user friendly and secure environment.</p>
              </div>
              <div class="col-12 text-center">
                <img src="assets/images/healthcare.png" class="img-fluid" alt="">
              </div>
            </div>

          </div>
          <div id="restaurants" class="tab-pane fade">

            <div class="row">
              <div class="col-12">
                <p><b>Business, Marketplace Websites & Apps</b></p>
                <p>We have successfully designed and developed solutions (web and mobile apps) for restaurants and companies providing food related market place services.</p>
                <p>Almost 60% of people use mobile phones to make restaurant reservations or place orders. Web and mobile applications make any restaurant or related service industry more efficient. They also make it easier to retain customer loyalty and attract newer customers.</p>
              </div>
              <div class="col-12 text-center">
                <img src="../../assets/images/web-mobile-apps-restaurants-irvinetek.png" style="width: 75%" class="img-fluid d-block mx-auto" alt="">
              </div>
            </div>

          </div>

          <div id="startups" class="tab-pane fade">

            <div class="row">
              <div class="col-12">
                <p><b>Consult, Discover, Develop, Grow</b></p>
                <p>Entrepreneurs & their ideas excite us like nothing else. Besides end-to-end web and mobile application design and development services, we have helped startups in refining their ideas, product discovery & marketing campaigns.</p>
                <p>Our services include architectural evaluation, quality assurance testing, security improvement, DevOps support, data analytics, cloud setup, bigdata and machine learning. Your idea is safe with us as we always sign a Non-Disclosure Agreement.</p>
              </div>
              <div class="col-12 text-center">
                <img src="../../assets/images/Startup-min.png" class="img-fluid" alt="">
              </div>
            </div>

          </div>


          <div id="retail" class="tab-pane fade">

            <div class="row">
              <div class="col-12">
                <p><b>Online Store, POS, Inventory, CRM</b></p>
                <p>Our cliental for web and mobile application solutions include small businesses as well as large retailers. We have even helped not for profit organizations to launch their retail store for charity purposes.</p>
                <p>Our services range from point of sales (POS) to comprehensive billing, inventory and financial modules for one or multiple locations. We also offer customized solutions for your customers to access your services at ease.</p>
              </div>
              <div class="col-12 text-center">
                <img src="../../assets/images/web-mobile-apps-retail-irvinetek.png" style="width: 80%" class="img-fluid d-block mx-auto" alt="">
              </div>
            </div>

          </div>
          <div id="realestate" class="tab-pane fade">

            <div class="row">
              <div class="col-12">
                <p><b>Business Website, Apps & Customer Support</b></p>
                <p>Realtors cannot work extended hours, however people looking to buy property are looking online 24/7 for their dream purchase. Online presence and active communication are the most important components of a successful real estate business.</p>
                <p>Several real-estate companies and independent realtors have hired us for customer support services. Visit our website:
                  <a style="text-decoration: none;color: black" target="_blank" href="https://ranecs.com">www.ranecs.com</a>
                  for affordable live chat, voice support or other customer service features.
                </p>
              </div>
              <div class="col-12 text-center">
                <img src="../../assets/images/web_mobile_apps_realestate_irvinetek.png" class="img-fluid d-block mx-auto" alt="">
              </div>
            </div>

          </div>
          <div id="publicservice" class="tab-pane fade">

            <div class="row">
              <div class="col-12">
                <p><b>Government, Charitable and NGOs</b></p>
                <p>We have helped several public sector & not-for-profit organizations with IT based solutions to improve their online presence and service delivery for citizens and customers.</p>
                <p>Whether public-sector department needs to run vaccination drive or a charity organization is working to feed the hungry, we assist them identify technological opportunities to address existing challenges.</p>
              </div>
              <div class="col-12 text-center">
                <img src="../../assets/images/web-mobile-apps-nonprofit-irvinetek.png" style="width: 60%" class="img-fluid d-block mx-auto" alt="">
              </div>
            </div>

          </div>
          <div id="edtech" class="tab-pane fade">

            <div class="row">
              <div class="col-12">
                <p><b>Learning, Consultation Solutions, Back Office</b></p>
                <p>We developed complete solution for a startup to market-place application (for web and mobile platforms) which connects prospective students with mentors and college admission councilors.</p>
                <p>Our team can help you with customized solutions for student and staff management, linear, adaptive & collaborative learning, virtual classrooms and student-parent-teacher communication.</p>
              </div>
              <div class="col-12 text-center" style="margin-top: 15px">
                <img src="../../assets/images/web_mobile_apps_edtech_irvinetek.png" class="img-fluid" alt="">
              </div>
            </div>

          </div>
          <div id="backOffice" class="tab-pane fade">

            <div class="row">
              <div class="col-12">
                <p><b>Data Analytics & Microsoft Ecosystem</b></p>
                <p>We are providing customized HR module services to several healthcare institutions including onboarding, payroll, time and attendance and leave management.</p>
                <p>We are providing customized HR module services to several healthcare institutions including onboarding, payroll, time and attendance and leave management.</p>
              </div>
              <div class="col-12  text-center">
                <img src="../../assets/images/web_mobile_apps_fintech_irvinetek.png" class="img-fluid" alt="">
              </div>
            </div>

          </div>

        </div>
      </div>

    </div>
  </div>

</section>


<!-- Camden Intro Section -->
<section id="camden" class="camden-section">
  <div class="container">
    <div class="camden-main">
      <div class="camden-image-col">
        <img src="assets/images/CH%20Logo%20Yellow%20Line.png" class="img-fluid camden-image" alt="Camden">
        <p class="m-0 font-weight-500 word-spacing-3 color-gold">Camden Health System</p>
        <p>Better Technology. Better Care.</p>
      </div>
      <div class=" camden-info-col pl-6">
        <p class="m-0">State-of-the-art HMIS</p>
        <p class="font-weight-500 word-spacing-3">Developed by IrvineTek</p>
        <p class="m-0">For more information</p>
        <p><a href="https://camdenhealthsys.com/" target="_blank">www.camdenhealthsys.com</a></p>
      </div>
    </div>
  </div>
</section>

<!--Resources section-->
<section id="insights" class="resources-section" style="padding: 40px 0px 20px 0px;">
  <div class="container">
    <h2><b>Insights</b></h2>

    <div class="row mt-3 d-none d-sm-none d-md-flex" style="margin-top: 30px!important;">

      <ng-container *ngFor="let blog of blogData;let i = index">
        <div class="col-12 col-sm-6 col-md-4" *ngIf="i < 6">
          <div class="first-blog">
            <a routerLink="/insights/{{blog.url}}">
              <img [src]="apiAddress + blog.image_url" alt="" style="width: 100%;" class="img-responsive">
            <div class="content">
              <p>{{blog.name}}</p>
            </div>
            </a>
          </div>
        </div>
      </ng-container>

    </div>

    <div class="story-slider owl-carousel owl-theme d-block d-sm-block d-md-none">
      <ng-container *ngFor="let date of blogMobileData;let i = index">
        <div class="item ml-0" *ngIf="i < 3">
          <div class="first-blog" *ngFor="let blog of date">
            <a routerLink="/insights/{{blog.url}}">
              <img src="{{apiAddress + blog.image_url}}" alt="" style="width: 100%;" class="img-responsive"></a>
            <div class="content">
              <p>{{blog.name}}</p>
            </div>
          </div>

        </div>
      </ng-container>

    </div>

<!--    <p class="more-blogs text-right mt-3"><a routerLink="/insights">More Insights ...</a></p>-->

  </div>
</section>


<!--About us section-->
<section id="" class="about-section" style="padding: 40px 0px 20px 0px;">
  <div class="container" style="">
<!--    <h2 class="py-0" style=""><b>How Can We Help?</b></h2>-->
    <h2><b>How Can We Help?</b></h2>

    <div class="row" style="margin-top: 22px">
      <div class="col-12 col-sm-12 col-md-6 align-items-center">
        <p>Any kind of digital transformation or application development project can be quite overwhelming. Absence of robust design, development & deployment plan by technology partner enhances risk of going over time and budget.</p>
        <p>Our agile consulting team carries out in-depth discovery & analysis of every project to propose solutions that are accurate in all estimates. Our software development team then ensures that these projects meet targets and are delivered with actual scope of work.</p>
        <p>Submit <a style="text-decoration: none;color: #212529;font-weight: bold" routerLink="/contact-us">online form</a> for <span class="show-mobile">free</span> no-obligation consultation.</p>
      </div>

      <div class="col-12 col-sm-12 col-md-6 text-center align-items-center">
        <div class="show-web">
          <p>We offer free initial consultation</p>
        </div>
        <div>
          <a style="text-decoration: none;color: #212529;font-weight: bold" routerLink="/estimate">Instant Estimate</a> |
          <a style="text-decoration: none;color: #212529;font-weight: bold" routerLink="/contact-us">Contact Us</a> |
          <a style="text-decoration: none;color: #212529;font-weight: bold" routerLink="/about-us">About Us</a>
        </div>
        <div>
          <p style="margin: 30px 0px 5px 0px">Follow Us:</p>
          <img src="assets/images/irvinetek-linkedin.png" class="img-fluid" style="width: 50px;margin: 0px 10px;">
          <img src="assets/images/irvinetek-facebook.png" class="img-fluid" style="width: 50px;margin: 0px 10px;">
          <img src="assets/images/irvinetek-twitter.png" class="img-fluid" style="width: 50px;margin: 0px 10px;">
        </div>
      </div>

<!--      <div class="col-12 col-sm-12 col-md-2">-->
<!--        <div>-->
<!--          <img src="assets/images/irvinetek-linkedin.png" class="img-fluid" style="width: 50px">-->
<!--          <a>LinkedIn</a>-->
<!--        </div>-->
<!--        <div>-->
<!--          <img src="assets/images/irvinetek-facebook.png" class="img-fluid" style="width: 50px">-->
<!--          <a>Facebook</a>-->
<!--        </div>-->
<!--        <div>-->
<!--          <img src="assets/images/irvinetek-twitter.png" class="img-fluid" style="width: 50px">-->
<!--          <a>Twitter</a>-->
<!--        </div>-->
<!--      </div>-->
    </div>

  </div>
</section>
